(() => {
  const $menuItems = document.querySelectorAll('.js-menu-item');
  const $navigation = document.querySelector('.js-navigation');
  const navigationHeight = ($navigation) ? $navigation.offsetHeight : null;

  const menuItemClicked = (event) => {
    event.preventDefault();

    const href = event.target.getAttribute('href');
    const $target = document.querySelector(href);
    const scrollTarget = $target.getBoundingClientRect().top;
    window.smoothScrollTo((window.pageYOffset + scrollTarget) - navigationHeight);
  };

  $menuItems.forEach((item) => item.addEventListener('click', menuItemClicked));
})();
